import Storage from "../../common/utils/storage.es6";

export default class Main {
    constructor() {
        this.STORAGE = new Storage();
        this.main = document.querySelector(".js-main");
        this.init();
    }

    init() {
        this.handleIntro();
    }

    handleIntro() {
        if (this.STORAGE.data.limitedScreeningIntro) {
            this.controllScroll();
        } else {
            this.skipIntro();
        }
    }

    controllScroll() {
        //初回アクセス時のみ、イントロ表示のため冒頭スクロール無効化
        if (this.STORAGE.data.limitedScreeningIntro) {
            document.body.classList.add("-lock");

            setTimeout(() => {
                document.body.classList.remove("-lock");
                // //スクロール前のアニメーション発火を防ぐため、scrollFuncはスクロール解禁後に初期化
                // new Scrollfunc();

                //イントロを表示したら、次回以降はスキップするように保存
                this.STORAGE.set("limitedScreeningIntro", false);
            }, 2900);
        }
    }

    skipIntro() {
        //リロード時は、直前の場所に遷移させるためにイントロはスキップ
        if (!this.STORAGE.data.limitedScreeningIntro) {
            this.main.classList.add("-skipintro");
        }
    }
}
